import React, { Component, Fragment } from "react";
// import Switch from 'rc-switch';
import { Form, FormGroup, Button, Modal, ModalHeader, ModalBody, ModalFooter, Label } from "reactstrap";

import { injectIntl } from "react-intl";
import { Alert, TimePicker, Input, Switch } from "antd";

import moment from "moment";
import { connect } from "react-redux";
import IntlMessages from "../../helpers/IntlMessages";

import { getRequestRestaurant, createRestaurantConfig, updateRestaurantConfig } from "../../redux/alacarte/actions";

class RestaurantsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showIcon: false,
      time: "",
      monday_open: "",
      monday_close: "",
      open_time: "",
      attributeForm: [],
      daysForAlacarte: ["mondays", "tuesdays", "wednesdays", "thursdays", "fridays", "saturdays", "sundays"],
      time_slots: {},
      config: {},
      updateAndCreateButtonStatus: false,
      configProps: null,
      guestCancelReservationTime: "",
      stopReservationBefore: "",
      maxGuestCount: "",
      guestOneResEachDay: false,
      guestOneResPerRestaurant: false,
      mainCourseRequired: false,
      disabledButtonAddSlot: false
    };
  }

  patchConfig = uuid => {
    const body = {};
    body.id = uuid;
    body.config = this.state.config;
    this.props.updateRestaurantConfig(body);
    this.setState({
      updateAndCreateButtonStatus: !this.state.updateAndCreateButtonStatus
    });
  };

  createConfig = (
    hotel_id,
    restaurant_name,
    restaurant_id,
    time_slots,
    guestCancelReservationTime,
    stopReservationBefore,
    maxGuestCount,
    guestOneResEachDay,
    guestOneResPerRestaurant,
    mainCourseRequired
  ) => {
    const body = {};
    body.hotel_id = String(hotel_id);
    body.restaurant_id = restaurant_id;
    body.restaurant_name = restaurant_name;
    body.time_slots = time_slots;
    body.guest_can_cancel_reservation_before_opens_at = Number(guestCancelReservationTime);
    body.stop_reservation_before_opens_at = Number(stopReservationBefore);
    body.max_guest_count = Number(maxGuestCount);
    body.guest_can_one_reservation_each_day = guestOneResEachDay;
    body.guest_can_one_reservation_per_restaurant = guestOneResPerRestaurant;
    body.main_course_selection_required = mainCourseRequired;
    this.props.createRestaurantConfig(body);
    this.setState({
      updateAndCreateButtonStatus: !this.state.updateAndCreateButtonStatus
    });
  };

  changeCancelAndToggleOff = () => {
    this.props.toggle();
    const hotel_id = this.props.hotelConfig.hotelId;
    this.props.getRequestRestaurant(hotel_id);
    this.setState({
      config: {},
      time_slots: {},
      guestCancelReservationTime: "",
      stopReservationBefore: "",
      maxGuestCount: "",
      guestOneResEachDay: false,
      guestOneResPerRestaurant: false,
      mainCourseRequired: false
    });
    this.setState({
      updateAndCreateButtonStatus: false
    });
  };

  handleChange = e => {
    this.setState({
      [e.target.name]: Number(e.target.value)
    });
  };

  handleChangeProps = e => {
    const { name } = e.target;
    const value = Number(e.target.value);
    this.setState(prevState => ({
      ...this.state.config,
      config: {
        ...prevState.config,
        [name]: value
      }
    }));
  };

  handleGuestResPerRestaurantSwitchStatus = checked => {
    this.setState({
      guestOneResPerRestaurant: !this.state.guestOneResPerRestaurant
    });
  };

  handleGuestResPerRestaurantSwitchStatusProps = checked => {
    this.setState(prevState => ({
      ...this.state.config,
      config: {
        ...prevState.config,
        guest_can_one_reservation_per_restaurant: checked
      }
    }));
  };

  handleMainCourseSwitchStatusProps = checked => {
    this.setState(prevState => ({
      ...this.state.config,
      config: {
        ...prevState.config,
        main_course_selection_required: checked
      }
    }));
  };

  handleMainCourseSwitchStatus = checked => {
    this.setState({
      mainCourseRequired: !this.state.mainCourseRequired
    });
  };

  handleGuestResSwitchStatus = checked => {
    this.setState({
      guestOneResEachDay: !this.state.guestOneResEachDay
    });
  };

  handleGuestResSwitchStatusProps = checked => {
    this.setState(prevState => ({
      ...this.state.config,
      config: {
        ...prevState.config,
        guest_can_one_reservation_each_day: checked
      }
    }));
  };

  handleChangeClose = (time, idx, day) => {
    let b;
    if (time) {
      const a = time._d;
      b = moment(a).format("HH:mm");
    }

    const days = this.state.time_slots[day];
    days[idx][this.picker.props.name] = b;
    this.setState({ ...this.state.time_slots });
  };

  handleChangeCloseProps = (time, idx, day) => {
    let b;
    if (time) {
      const a = time._d;
      b = moment(a).format("HH:mm");
    }
    let days;
    if (this.state.config && this.state.config.time_slots && this.state.config.time_slots[day]) {
      days = this.state.config.time_slots[day];
      days[idx][this.picker.props.name] = b;
    } else {
      days = this.props.config.time_slots[day];
      days[idx][this.picker.props.name] = b;
    }
    if (this.state.config && this.state.config.time_slots && this.state.config.time_slots[day]) {
      this.setState(prevState => ({
        config: {
          // ...this.state.config,
          ...prevState.config,
          time_slots: {
            ...this.props.config.time_slots,
            ...prevState.config.time_slots,
            [day]: [...prevState.config.time_slots[day]]
          }
        }
      }));
    } else {
      this.setState(prevState => ({
        config: {
          ...this.state.config,
          time_slots: {
            ...this.props.config.time_slots,
            [day]: [...this.props.config.time_slots[day]]
          }
        }
      }));
    }
  };

  handleChangeQuotaProps = (e, idx, day) => {
    if (this.state.config && this.state.config.time_slots) {
      const days = this.state.config.time_slots[day];
      days[idx].quota = Number(e.target.value);
      // this.setState({ ...this.state.config });
      this.setState(prevState => ({
        ...this.state.config,
        config: {
          ...prevState.config,
          time_slots: {
            // ...prevState.config.time_slots,
            // [day]:
            ...this.state.config.time_slots
          }
        }
      }));
    } else {
      const days = this.props.config.time_slots[day];
      days[idx].quota = Number(e.target.value);
      this.setState(prevState => ({
        ...this.state.config,
        config: {
          ...prevState.config,
          time_slots: {
            ...this.props.config.time_slots
          }
        }
      }));
    }
  };

  handleChangeQuota = (e, idx, day) => {
    const days = this.state.time_slots[day];
    days[idx].quota = Number(e.target.value);
    this.setState({ ...this.state.time_slots });
  };

  handleChangeOpen = (time, idx, day) => {
    let b;
    if (time) {
      const a = time._d;
      b = moment(a).format("HH:mm");
    }

    const days = this.state.time_slots[day];
    days[idx][this.pickerOpen.props.name] = b;
    this.setState({ ...this.state.time_slots });
  };

  handleChangeOpenProps = (time, idx, day, valueForTime) => {
    let b;
    if (time) {
      const a = time._d;
      b = moment(a).format("HH:mm");
    }

    let days;
    if (this.state.config && this.state.config.time_slots && this.state.config.time_slots[day]) {
      days = this.state.config.time_slots[day];
      days[idx][this.pickerOpen.props.name] = b;
    } else {
      days = this.props.config.time_slots[day];
      days[idx][this.pickerOpen.props.name] = b;
    }

    if (this.state.config && this.state.config.time_slots && this.state.config.time_slots[day]) {
      this.setState(prevState => ({
        config: {
          // ...this.state.config,
          ...prevState.config,
          time_slots: {
            ...this.props.config.time_slots,
            ...prevState.config.time_slots,
            [day]: [...prevState.config.time_slots[day]]
          }
        }
      }));
    } else {
      this.setState(prevState => ({
        config: {
          ...this.state.config,
          time_slots: {
            ...this.props.config.time_slots,
            [day]: [...this.props.config.time_slots[day]]
          }
        }
      }));
    }
  };

  addSlot = (res, all_day) => {
    if (all_day === true) {
      if (this.state.time_slots[res] && this.state.time_slots[res].length > 0) {
        this.setState(prevState => ({
          time_slots: {
            ...prevState.time_slots,
            [res]: [{ opens_at: "00:00", closes_at: "23:59", quota: 0, all_day: true }]
          }
        }));
      } else {
        this.setState(prevState => ({
          time_slots: {
            ...prevState.time_slots,
            [res]: [{ opens_at: "00:00", closes_at: "23:59", quota: 0, all_day: true }]
          }
        }));
      }
    }
    if (all_day === undefined) {
      if (
        this.state.time_slots &&
        this.state.time_slots[res] &&
        this.state.time_slots[res][0] !== undefined &&
        this.state.time_slots[res][0].all_day === true
      ) {
        return;
      }
      if (this.state.time_slots[res] && this.state.time_slots[res].length > 0) {
        this.setState(prevState => ({
          time_slots: {
            ...prevState.time_slots,
            [res]: [...prevState.time_slots[res], { opens_at: "00:00", closes_at: "00:00", quota: 0 }]
          }
        }));
      } else {
        this.setState(prevState => ({
          time_slots: {
            ...prevState.time_slots,
            [res]: [{ opens_at: "00:00", closes_at: "00:00", quota: 0 }]
          }
        }));
      }
    }
  };

  addSlotProps = (res, all_day) => {
    if (all_day === true) {
      if (this.state.config && this.state.config.time_slots && this.state.config.time_slots[res]) {
        this.setState(prevState => ({
          config: {
            // ...this.state.config,
            ...prevState.config,
            time_slots: {
              ...this.props.config.time_slots,
              ...prevState.config.time_slots,
              [res]: [{ opens_at: "00:00", closes_at: "23:59", quota: 0, all_day: true }]
            }
          }
        }));
      } else if (this.props.config && this.props.config.time_slots && this.props.config.time_slots[res]) {
        this.setState(prevState => ({
          config: {
            ...this.state.config,
            time_slots: {
              ...this.props.config.time_slots,
              [res]: [{ opens_at: "00:00", closes_at: "23:59", quota: 0, all_day: true }]
            }
          }
        }));
      } else {
        this.setState(prevState => ({
          config: {
            ...prevState.config,
            time_slots: {
              ...prevState.config.time_slots,
              ...this.props.config.time_slots,
              [res]: [{ opens_at: "00:00", closes_at: "23:59", quota: 0, all_day: true }]
            }
          }
        }));
      }
    }
    if (all_day === undefined) {
      // (this.props.config && this.props.config.time_slots && !this.props.config.time_slots[res])
      if (
        (this.state.config &&
          this.state.config.time_slots &&
          this.state.config.time_slots[res] &&
          this.state.config.time_slots[res][0] !== undefined &&
          this.state.config.time_slots[res][0].all_day === true) ||
        (this.props.config &&
          this.props.config.time_slots &&
          this.props.config.time_slots[res] &&
          this.props.config.time_slots[res][0] !== undefined &&
          this.props.config.time_slots[res][0].all_day === true)
      ) {
        this.setState({
          errorAddSlotForAllDay: true
        });
        return;
      }
      if (this.state.config && this.state.config.time_slots && this.state.config.time_slots[res]) {
        this.setState(prevState => ({
          config: {
            // ...this.state.config,
            ...prevState.config,
            time_slots: {
              ...this.props.config.time_slots,
              ...prevState.config.time_slots,
              [res]: [...prevState.config.time_slots[res], { opens_at: "00:00", closes_at: "00:00", quota: 0 }]
            }
          }
        }));
      } else if (this.props.config && this.props.config.time_slots && this.props.config.time_slots[res]) {
        this.setState(prevState => ({
          config: {
            ...this.state.config,
            time_slots: {
              ...this.props.config.time_slots,
              [res]: [...this.props.config.time_slots[res], { opens_at: "00:00", closes_at: "00:00", quota: 0 }]
            }
          }
        }));
      } else {
        this.setState(prevState => ({
          config: {
            ...prevState.config,
            time_slots: {
              ...prevState.config.time_slots,
              ...this.props.config.time_slots,
              [res]: [{ opens_at: "00:00", closes_at: "00:00", quota: 0 }]
            }
          }
        }));
      }
    }
  };

  removeSlotProps = (res, idx) => {
    if (this.state.config && this.state.config.time_slots && this.state.config.time_slots[res]) {
      this.setState(prevState => ({
        // ...this.state.config,
        config: {
          ...prevState.config,
          time_slots: {
            ...this.props.config.time_slots,
            ...prevState.config.time_slots,
            [res]: prevState.config.time_slots[res].filter((_, i) => i !== idx)
          }
        }
      }));
    } else {
      this.setState(prevState => ({
        config: {
          ...this.state.config,
          time_slots: {
            ...this.props.config.time_slots,
            [res]: this.props.config.time_slots[res].filter((_, i) => i !== idx)
          }
        }
      }));
    }
  };

  removeSlot = (res, idx) => {
    this.setState(prevState => ({
      time_slots: {
        ...prevState.time_slots,
        [res]: prevState.time_slots[res].filter((_, i) => i !== idx)
      }
    }));
  };

  render() {
    const { messages } = this.props.intl;
    const messageSuccess = <IntlMessages id="alacarte.success" />;
    const messageError = <IntlMessages id="user.passwordChangeError" />;
    const formatTime = "HH:mm";

    const hotel_id = this.props.hotelConfig.hotelId;
    const restaurant_name = this.props.name;
    const restaurant_id = this.props.id;
    const uuid = this.props.config.id;
    const {
      time_slots,
      guestCancelReservationTime,
      stopReservationBefore,
      maxGuestCount,
      guestOneResEachDay,
      guestOneResPerRestaurant,
      mainCourseRequired
    } = this.state;

    let mapDataSlots;
    let mapDataSlotsa;
    if (this.props.restaurantID && this.props.config && this.props.config.time_slots) {
      mapDataSlotsa = this.props.alacarteApp.getRestaurants.filter((res, id) => res.id == this.props.restaurantID);
      mapDataSlots = mapDataSlotsa[0].config.time_slots;
      if (this.state.config && this.state.config.time_slots) {
        mapDataSlots = this.state.config.time_slots;
      }
    }

    return (
      <div>
        <Modal isOpen={this.props.modal}>
          <ModalHeader>
            {/* <IntlMessages id="link.modalheader" /> */}
            {this.props.name}
          </ModalHeader>
          <div>
            {(this.props.alacarteApp.createRestaurantLoading === true &&
              this.props.alacarteApp.createRestaurantError === "" &&
              this.state.updateAndCreateButtonStatus === true) ||
            (this.props.alacarteApp.updateRestaurantLoading === true &&
              this.props.alacarteApp.updateRestaurantError === "" &&
              this.state.updateAndCreateButtonStatus === true) ? (
              <div>
                <ModalBody>
                  {/* <div>Loading...</div> */}
                  <div className="loading" />
                </ModalBody>
                <ModalFooter>
                  <Button color="secondary" onClick={() => this.changeCancelAndToggleOff()}>
                    <IntlMessages id="user.cancel" />
                  </Button>
                </ModalFooter>
              </div>
            ) : (this.props.alacarteApp.createRestaurantLoading === false &&
                this.props.alacarteApp.createRestaurantError !== "" &&
                this.state.updateAndCreateButtonStatus === true) ||
              (this.props.alacarteApp.updateRestaurantLoading === false &&
                this.props.alacarteApp.updateRestaurantError !== "" &&
                this.state.updateAndCreateButtonStatus === true) ? (
              <div>
                <ModalBody>
                  {/* <div>Something went wrong... please try again...</div> */}
                  <div>
                    <div>
                      {" "}
                      <Alert description={messageError} type="error" showIcon />
                    </div>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Button color="secondary" onClick={() => this.changeCancelAndToggleOff()}>
                    <IntlMessages id="user.close" />
                  </Button>
                </ModalFooter>
              </div>
            ) : (this.props.alacarteApp.createRestaurantConfig &&
                this.props.alacarteApp.createRestaurantConfig.length > 0 &&
                this.props.alacarteApp.createRestaurantError === "" &&
                this.props.alacarteApp.createRestaurantLoading === false &&
                this.state.updateAndCreateButtonStatus === true) ||
              (!this.props.alacarteApp.updateRestaurantConfig &&
                this.props.alacarteApp.updateRestaurantError === "" &&
                this.props.alacarteApp.updateRestaurantLoading === false &&
                this.state.updateAndCreateButtonStatus === true) ? (
              <div>
                <ModalBody>
                  <div>
                    {" "}
                    <Alert description={messageSuccess} type="success" showIcon />
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Button color="secondary" onClick={() => this.changeCancelAndToggleOff()}>
                    <IntlMessages id="user.close" />
                  </Button>
                </ModalFooter>
              </div>
            ) : (
              <div>
                <ModalBody>
                  <Form>
                    <FormGroup>
                      <div id="monday">
                        <div>
                          {this.props.config === "" ? (
                            <div>
                              {this.state.daysForAlacarte.map((res, index) => {
                                return (
                                  <div key={index}>
                                    <div className="mb-1 mt-3">
                                      <Label>
                                        {/* <IntlMessages id="bookingDetails.checkin_checkout_time" /> */}
                                        <h3>
                                          <IntlMessages id={`alacarte.${res}`} />
                                        </h3>
                                      </Label>{" "}
                                      <Button
                                        onClick={() => this.addSlot(res)}
                                        type="button"
                                        className="btn outline-light flex-grow-1 ml-3 mr-2 float-right"
                                        color="outline-success"
                                        size="xs"
                                      >
                                        + <IntlMessages id="alacarte.addSlot" />
                                      </Button>
                                      <Button
                                        onClick={() => this.addSlot(res, true)}
                                        type="button"
                                        className="btn outline-light flex-grow-1 ml-3 mr-2 float-right"
                                        color="outline-success"
                                        size="xs"
                                      >
                                        <IntlMessages id="alacarte.allday" />
                                      </Button>
                                    </div>

                                    <div />
                                    {this.state.time_slots[res] && this.state.time_slots[res].length > 0 ? (
                                      <div>
                                        {this.state.time_slots[res].map((val, idx) => {
                                          const openingID = `${idx}`;
                                          const closingID = `${idx}`;
                                          const inputID = `${idx}`;
                                          return (
                                            <div>
                                              {/* <label htmlFor={openingID}>{`Open #${idx + 1}`}</label> */}
                                              <TimePicker
                                                ref={node => {
                                                  this.pickerOpen = node;
                                                }}
                                                type="text"
                                                name="opens_at"
                                                dataId={idx}
                                                id={openingID}
                                                onChange={e => this.handleChangeOpen(e, idx, res)}
                                                value={val.opens_at ? moment(`${val.opens_at}`, formatTime) : moment(`00:00`, formatTime)}
                                                format={formatTime}
                                                placeholder=""
                                                disabled={!!(val.all_day && val.all_day == true)}
                                                popupClassName="opens_at"
                                                className="w-25 mr-2"
                                              />
                                              {/* <label htmlFor={closingID}>Close</label> */}
                                              {"-"}
                                              <TimePicker
                                                ref={node => {
                                                  this.picker = node;
                                                }}
                                                type="text"
                                                name="closes_at"
                                                data-id={idx}
                                                id={closingID}
                                                onChange={e => this.handleChangeClose(e, idx, res)}
                                                value={val.closes_at ? moment(`${val.closes_at}`, formatTime) : moment(`00:00`, formatTime)}
                                                format={formatTime}
                                                disabled={!!(val.all_day && val.all_day == true)}
                                                placeholder=""
                                                popupClassName="closes_at"
                                                className="w-25 ml-2"
                                              />
                                              <label htmlFor={inputID} className="ml-2">
                                                <IntlMessages id="alacarte.quota" />
                                              </label>
                                              <Input
                                                type="number"
                                                min="0"
                                                name="quota"
                                                data-id={idx}
                                                id={inputID}
                                                onChange={e => this.handleChangeQuota(e, idx, res)}
                                                placeholder={messages["alacarte.count"]}
                                                // value={val.quota === 0 ? '' : val.quota}
                                                value={this.state.time_slots[res][idx].quota === 0 ? "" : this.state.time_slots[res][idx].quota}
                                                className="w-15 ml-2"
                                              />
                                              <Button
                                                onClick={() => this.removeSlot(res, idx)}
                                                type="button"
                                                className="btn outline-light flex-grow-1 ml-2"
                                                color="outline-danger"
                                                size="xs"
                                              >
                                                -
                                              </Button>
                                            </div>
                                          );
                                        })}
                                        <hr />
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                );
                              })}
                              <div className="mb-4">
                                <IntlMessages id="alacarte.stop_res_before_opens_at" />:{" "}
                                <Input
                                  type="number"
                                  min="0"
                                  name="stopReservationBefore"
                                  onBlur={e => this.handleChange(e)}
                                  defaultValue={this.state.stopReservationBefore}
                                />
                              </div>
                              <div className="mb-4">
                                <IntlMessages id="alacarte.guest_cancel_res_before_open_at" />:{" "}
                                <Input
                                  type="number"
                                  min="0"
                                  name="guestCancelReservationTime"
                                  onBlur={e => this.handleChange(e)}
                                  defaultValue={this.state.guestCancelReservationTime}
                                />
                              </div>

                              <div className="mb-4">
                                <IntlMessages id="alacarte.max_guest_count" />:{" "}
                                <Input
                                  type="number"
                                  min="0"
                                  name="maxGuestCount"
                                  onBlur={e => this.handleChange(e)}
                                  defaultValue={this.state.maxGuestCount}
                                />
                              </div>

                              <div className="mb-4">
                                <IntlMessages id="alacarte.main_course" />:{" "}
                                <Switch
                                  // checked={true}
                                  // className="custom-switch custom-switch-primary custom-switch-small"
                                  onChange={e => this.handleMainCourseSwitchStatus(e)}
                                />
                              </div>

                              <div className="mb-4">
                                <IntlMessages id="alacarte.guest_one_res_each_day" />:{" "}
                                <Switch
                                  // checked={true}
                                  // className="custom-switch custom-switch-primary custom-switch-small"
                                  onChange={e => this.handleGuestResSwitchStatus(e)}
                                />
                              </div>

                              <div className="mb-0">
                                <IntlMessages id="alacarte.guest_one_res_per_resturant" />:{" "}
                                <Switch
                                  // checked={true}
                                  // className="custom-switch custom-switch-primary custom-switch-small"
                                  onChange={e => this.handleGuestResPerRestaurantSwitchStatus(e)}
                                />
                              </div>
                            </div>
                          ) : (
                            <div>
                              {this.state.daysForAlacarte.map((res, index) => {
                                return (
                                  <div>
                                    <div className="mb-1 mt-3">
                                      <Label>
                                        {/* <IntlMessages id="bookingDetails.checkin_checkout_time" /> */}
                                        <h3>
                                          <IntlMessages id={`alacarte.${res}`} />
                                        </h3>
                                      </Label>{" "}
                                      <Button
                                        onClick={() => this.addSlotProps(res)}
                                        type="button"
                                        className="btn outline-light flex-grow-1 ml-3 mr-2 float-right"
                                        color="outline-success"
                                        size="xs"
                                      >
                                        + <IntlMessages id="alacarte.addSlot" />
                                      </Button>
                                      <Button
                                        onClick={() => this.addSlotProps(res, true)}
                                        type="button"
                                        className="btn outline-light flex-grow-1 ml-3 mr-2 float-right"
                                        color="outline-success"
                                        size="xs"
                                      >
                                        <IntlMessages id="alacarte.allday" />
                                      </Button>
                                    </div>

                                    {mapDataSlots[res] && mapDataSlots[res].length > 0 ? (
                                      <div>
                                        {mapDataSlots[res].map((val, idx) => {
                                          const openingID = `${idx}`;
                                          const closingID = `${idx}`;
                                          const inputID = `${idx}`;
                                          return (
                                            <div>
                                              {/* <label htmlFor={openingID}>{`Open #${idx + 1}`}</label> */}
                                              <TimePicker
                                                ref={node => {
                                                  this.pickerOpen = node;
                                                }}
                                                type="text"
                                                name="opens_at"
                                                dataId={idx}
                                                id={openingID}
                                                onChange={e => this.handleChangeOpenProps(e, idx, res)}
                                                value={val.opens_at ? moment(`${val.opens_at}`, formatTime) : moment(`00:00`, formatTime)}
                                                format={formatTime}
                                                disabled={!!(val.all_day && val.all_day == true)}
                                                placeholder=""
                                                className="w-25 mr-2"
                                              />
                                              {/* <label htmlFor={closingID}>Close</label> */}
                                              {"-"}
                                              <TimePicker
                                                ref={node => {
                                                  this.picker = node;
                                                }}
                                                type="text"
                                                name="closes_at"
                                                data-id={idx}
                                                id={closingID}
                                                onChange={e => this.handleChangeCloseProps(e, idx, res)}
                                                value={val.closes_at ? moment(`${val.closes_at}`, formatTime) : moment(`00:00`, formatTime)}
                                                format={formatTime}
                                                disabled={!!(val.all_day && val.all_day == true)}
                                                placeholder=""
                                                className="w-25 ml-2"
                                              />
                                              <label htmlFor={inputID} className="ml-2">
                                                <IntlMessages id="alacarte.quota" />
                                              </label>
                                              <Input
                                                type="number"
                                                min="0"
                                                name="quotaProps"
                                                data-id={`${idx}props`}
                                                id={`${inputID}props`}
                                                onChange={e => this.handleChangeQuotaProps(e, idx, res)}
                                                placeholder={messages["alacarte.count"]}
                                                value={val.quota === 0 ? "" : val.quota}
                                                className="w-15 ml-2"
                                              />
                                              <Button
                                                onClick={() => this.removeSlotProps(res, idx)}
                                                type="button"
                                                className="btn outline-light flex-grow-1 ml-2"
                                                color="outline-danger"
                                                size="xs"
                                              >
                                                -
                                              </Button>
                                            </div>
                                          );
                                        })}
                                        <hr />
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                );
                              })}
                              <div className="mb-4">
                                <IntlMessages id="alacarte.stop_res_before_opens_at" />:{" "}
                                <Input
                                  id="stop_res"
                                  type="number"
                                  min="0"
                                  name="stop_reservation_before_opens_at"
                                  onBlur={e => this.handleChangeProps(e)}
                                  defaultValue={
                                    this.state.config.stop_reservation_before_opens_at || this.state.config.stop_reservation_before_opens_at === ""
                                      ? this.state.config.stop_reservation_before_opens_at
                                      : this.props.config.stop_reservation_before_opens_at
                                  }
                                />
                              </div>
                              <div className="mb-4">
                                {" "}
                                <IntlMessages id="alacarte.guest_cancel_res_before_open_at" />:{" "}
                                <Input
                                  id="guest_can"
                                  type="number"
                                  min="0"
                                  name="guest_can_cancel_reservation_before_opens_at"
                                  onBlur={e => this.handleChangeProps(e)}
                                  defaultValue={
                                    this.state.config.guest_can_cancel_reservation_before_opens_at ||
                                    this.state.config.guest_can_cancel_reservation_before_opens_at === ""
                                      ? this.state.config.guest_can_cancel_reservation_before_opens_at
                                      : this.props.config.guest_can_cancel_reservation_before_opens_at
                                  }
                                />
                              </div>

                              <div className="mb-4">
                                {" "}
                                <IntlMessages id="alacarte.max_guest_count" />:{" "}
                                <Input
                                  id="max_guest"
                                  type="number"
                                  min="0"
                                  name="max_guest_count"
                                  onBlur={e => this.handleChangeProps(e)}
                                  defaultValue={
                                    this.state.config.max_guest_count || this.state.config.max_guest_count === ""
                                      ? this.state.config.max_guest_count
                                      : this.props.config.max_guest_count
                                  }
                                />
                              </div>

                              <div className="mb-4">
                                {" "}
                                <IntlMessages id="alacarte.main_course" />:{" "}
                                <Switch
                                  defaultChecked={this.props.config.main_course_selection_required}
                                  // className="custom-switch custom-switch-primary custom-switch-small"
                                  onChange={e => this.handleMainCourseSwitchStatusProps(e)}
                                />
                              </div>

                              <div className="mb-4">
                                <IntlMessages id="alacarte.guest_one_res_each_day" />:{" "}
                                <Switch
                                  defaultChecked={this.props.config.guest_can_one_reservation_each_day}
                                  // className="custom-switch custom-switch-primary custom-switch-small"
                                  onChange={e => this.handleGuestResSwitchStatusProps(e)}
                                />
                              </div>

                              <div className="mb-0">
                                <IntlMessages id="alacarte.guest_one_res_per_resturant" />:{" "}
                                <Switch
                                  defaultChecked={this.props.config.guest_can_one_reservation_per_restaurant}
                                  // className="custom-switch custom-switch-primary custom-switch-small"
                                  onChange={e => this.handleGuestResPerRestaurantSwitchStatusProps(e)}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                  </Form>
                </ModalBody>

                <ModalFooter>
                  {this.props.config === "" ? (
                    <Button
                      color="primary"
                      type="submit"
                      onClick={() =>
                        this.createConfig(
                          hotel_id,
                          restaurant_name,
                          restaurant_id,
                          time_slots,
                          guestCancelReservationTime,
                          stopReservationBefore,
                          maxGuestCount,
                          guestOneResEachDay,
                          guestOneResPerRestaurant,
                          mainCourseRequired
                        )
                      }
                    >
                      <IntlMessages id="user.create" />
                    </Button>
                  ) : (
                    <Button color="primary" type="submit" onClick={() => this.patchConfig(uuid)}>
                      <IntlMessages id="user.update" />
                    </Button>
                  )}
                  <Button color="secondary" onClick={() => this.changeCancelAndToggleOff()}>
                    <IntlMessages id="user.cancel" />
                  </Button>
                </ModalFooter>
              </div>
            )}
          </div>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = ({ alacarteApp, settings }) => {
  const { locale, hotelConfig } = settings;
  return { alacarteApp, locale, hotelConfig };
};

export default injectIntl(
  connect(
    mapStateToProps,
    {
      getRequestRestaurant,
      createRestaurantConfig,
      updateRestaurantConfig
    }
  )(RestaurantsModal)
);
